<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>员工任务详情</span>
      <el-button
        type="primary"
        style="width: 92px"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div>
          <span class="gray">员工号</span>
          <span style="margin-right:50px">{{info.recommender_code}}</span>
          <span class="gray">员工姓名</span>
          <span style="margin-right:50px">{{info.recommender_name}}</span>
          <span class="gray">员工手机号</span>
          <span>{{info.phone}}</span>
        </div>
        <div style="margin:15px 0">
          <span class="gray">任务周</span>
          <el-date-picker
            v-model="date"
            type="week"
            format="yyyy 第 WW 周"
            value-format="yyyy-MM-dd"
            :clearable="false"
            :picker-options="pickerOptions"
            @change="(value)=>{return changeWeek(value,1)}"
            style="width: 160px; margin-left: 6px"
          >
          </el-date-picker>
        </div>
        <div>
          <span class="week_data">{{weekData}}</span>
          <span class="gray">任务订单数</span>
          <span style="margin-right:50px;color:#FF7430">{{info.order_num}}</span>
          <span class="gray">订单有效门槛</span>
          <span style="margin-right:50px;color:#FF7430">{{info.order_valid_price}}</span>
          <span class="gray">本周订单数</span>
          <span style="margin-right:50px;color:#FF7430">{{info.auth_count}}</span>
          <span class="gray">任务订单金额</span>
          <span style="margin-right:50px;color:#FF7430">{{info.order_price}}</span>
          <span class="gray">本周订单金额</span>
          <span style="margin-right:50px;color:#FF7430">{{info.price_total}}</span>

        </div>
        <div style="text-align: left;margin:20px 0 10px">
          <span>本周处方订单支付记录</span>
        </div>

        <div style="border: solid 1px #c9cbd6;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1200px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="create_time"
              label="开方时间"
            />
            <el-table-column
              prop="pay_time"
              label="支付时间"
            />

            <el-table-column
              prop="user_name"
              label="患者姓名"
            />
            <el-table-column
              prop="doctor_name"
              label="医生姓名"
            />
            <el-table-column
              prop="pay_money"
              label="订单金额"
            />
            <el-table-column label="订单状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status==1">待审核</span>
                <span v-if="scope.row.status==2">待发药</span>
                <span v-if="scope.row.status==3">待收货</span>
                <span v-if="scope.row.status==4">已完成</span>
                <span v-if="scope.row.status==5">不通过</span>
                <span v-if="scope.row.status==6">平台退款</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="toDetail(scope.row.order_id)"
                >订单详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align:center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      info: {},
      week: '',
      date: '',
      weekData: '',
      pickerOptions: {
        firstDayOfWeek: 1
      },
      recommender_code: this.$route.query.recommender_code
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    let date = this.$route.query.date;
    this.changeWeek(date);
    this.date = date;
  },
  methods: {
    //改变周
    changeWeek(value) {
      let now = new Date(value);
      let now_day = now.getDay();
      if (now_day == 0) {
        now_day = 7;
      }
      let now_time = now.getTime();
      let monDay = dayjs(
        new Date(now_time + 24 * 60 * 60 * 1000 * (1 - now_day))
      ).format('MM-DD');
      let sunDay = dayjs(
        new Date(now_time + 24 * 60 * 60 * 1000 * (7 - now_day))
      ).format('MM-DD');

      let d1 = new Date(value);
      let d2 = new Date(value);
      d2.setMonth(0);
      d2.setDate(1);
      let rq = d1 - d2;
      let days = Math.ceil(rq / (24 * 60 * 60 * 1000));
      let num = Math.ceil(days / 7);
      let year = dayjs(value).year();

      this.weekData = year + '第' + num + '周 ' + monDay + '~' + sunDay;
      this.week = year + '-' + monDay + '~' + year + '-' + sunDay;
      this.getInfo();
      this.getList();
    },
    //员工详情
    getInfo() {
      let data = {
        recommender_code: this.recommender_code,
        week: this.week
      };
      this.axios.post('platform/Activity/getWeekTaskInfo', data).then((res) => {
        this.info = res.data.info;
        this.info.order_num = this.info.order_num
          ? this.info.order_num
          : '该周无任务';
      });
    },
    //获取列表
    getList() {
      let data = {
        recommender_code: this.recommender_code,
        week: this.week,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      this.axios.post('platform/Activity/weekTaskList', data).then((res) => {
        this.totalNum = res.data.total;
        this.tableData = res.data.list.map((item) => {
          item.create_time = dayjs
            .unix(item.create_time)
            .format('YYYY-MM-DD HH:mm');
          item.pay_time = dayjs.unix(item.pay_time).format('YYYY-MM-DD HH:mm');
          return item;
        });
      });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //订单详情
    toDetail(order_id) {
      this.$router.push({
        path: '/home/order/orderdetail',
        query: { order_id }
      });
    },
    back() {
      history.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.gray {
  color: #747981;
  margin-right: 10px;
}
.week_data {
  font-weight: 700;
  margin-right: 20px;
}
</style>